export const DATE_PICKER_EVENTS = {
  DATE_SELECTED: "calendar.dateSelected",
  DATE_CHANGED: "dates-changed",
};

export const AVAILABLE_NOW_SERVICE_EVENTS = {
  SET_AVAILABLE_NOW: "set-available_now",
};

export const POSTCODE_SERVICE_EVENTS = {
  SET_POSTCODE: "set-postcode",
};

export const SUBSCRIPTION_PLANS_STARTING = 99;

export const ALL_SUBSCRIPTION_TIERS = ["legacy", "lite", "premium", "ultimate"];

export const BACKUP_PRICE_DOLLARS = 15
